import { Block, Check, Delete, Edit } from "@mui/icons-material";

export const getCompanyActions =
  ({
    navigate,
    routerPaths,
    setSelectedUser,
    setSelectedAction,
    setDialogOpen,
  }) =>
  (status) =>
    [
      {
        icon: Edit,
        tooltip: "Modifica",
        onClick: (rowId) => navigate(`${routerPaths.updateUser}/${rowId}`),
      },
      {
        icon: status === "Bloccato" ? Check : Block,
        tooltip: status === "Bloccato" ? "Attiva" : "Blocca",
        onClick: (rowId) => {
          setSelectedUser(rowId);
          setSelectedAction(status === "Bloccato" ? "unblock" : "block");
          setDialogOpen(true);
        },
      },
      {
        icon: Delete,
        tooltip: "Elimina",
        onClick: (rowId) => {
          setSelectedUser(rowId);
          setSelectedAction("delete");
          setDialogOpen(true);
        },
      },
    ];
